import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Gallery } from './components/Gallery';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2wj8dbo48im46">
      <div className="w-full bg-white" data-id="element-1" data-mp="2wi5l9cv6edmo">
        <main data-id="element-2" data-mp="28tmej1rry8wp">
          <Hero data-id="element-3" data-mp="28t4kmbsl46ry" />
          <ProofBar data-id="element-4" data-mp="28sl48zil1qg1" />
          <Problem data-id="element-5" data-mp="28s2ynca15zvg" />
          <Solution data-id="element-6" data-mp="23vkzqt1dsvr1" />
          <WhatYouGet data-id="element-7" data-mp="23u9tmmkgrbwr" />
          <Gallery data-id="element-8" data-mp="23ut9zyugts8o" />
          <Bonuses data-id="element-9" data-mp="23t8ea5wf0398" />
          <Pricing data-id="element-10" data-mp="3ik7gwiph6frp" />
          <Testimonials data-id="element-11" data-mp="3ikr0s4yore8d" />
          <Guarantee data-id="element-12" data-mp="3ij61k21ff746" />
          <Faq data-id="element-13" data-mp="3ihv2ugmu8pjx" />
        </main>
        <Footer data-id="element-14" data-mp="3mlayb9n68jv1" />
      </div>
    </MotionConfig>;
}